module.exports = __webpack_public_path__ + "static/media/repeat-teal.0ccff0f6.svg";